export default {
  fortuneType: {
    daily: '日運',
    weekly: '週運',
    monthly: '月運',
    yearly: '年運',
  },
  generateCard: '生成{{type}}分享卡片',
  previewHint: '預覽效果如下，可直接分享給好友',
  overallScore: '綜合得分',
  scanQr: '掃碼獲取完整運勢報告',
  brandSlogan: '洞悉命理 · 掌控乾坤',
  boostMe: '給我助力',
  boostedMe: '已助力',
  boostHint: '點擊助力，為命主積攢好運能量',
  boostSuccess: '助力成功！已為命主積攢好運',
  saveCard: '保存卡片',
  shareTo: '分享到',
  selectPlatform: '選擇分享平台',
  reportBadge: '{{type}}報告',
  reportCard: '{{type}}分享卡片',
  generateHint: '生成專屬命理卡片，分享給朋友',
  saveImage: '保存圖片',
  shareToFriend: '分享給好友',
  scanDownload: '掃碼測算',
  brandName: '命理乾坤',
  brandSub: '專業命理 · 精準預測 · 優化指引',
  scanReport: '掃碼獲取完整報告 →',
  exclusiveReport: '{{year}}年{{month}}月 · 專屬命理報告',
  zodiacPrefix: '屬',
  profileDefault: '命主',
  career: {
    label: '事業命理',
    subLabel: '揭示職場命格·洞悉升遷時機',
    h1: '事業命格深度解析',
    h2: '升遷時機精準推演',
    h3: '職場貴人方位指引',
    h4: '事業能量卡護航輔助',
  },
  love: {
    label: '愛情命理',
    subLabel: '解讀情緣密碼·探索姻緣時機',
    h1: '愛情命格全面解讀',
    h2: '姻緣時機精準指引',
    h3: '桃花運勢月度分析',
    h4: '專屬情緣運勢卡',
  },
  wealth: {
    label: '財富命理',
    subLabel: '探索財富密碼·把握財運時機',
    h1: '財富命格全面解析',
    h2: '偏財正財運勢推演',
    h3: '財運時機月度指引',
    h4: '財富能量卡護財輔助',
  },
  relation: {
    label: '人際命理',
    subLabel: '解讀人緣磁場·改善人際困擾',
    h1: '人緣磁場深度解析',
    h2: '貴人方位精準指引',
    h3: '職場人際全面優化',
    h4: '人際能量卡守護輔助',
  },
  baziShare: {
    cardTitle: '八字命理分享卡片',
    badge: '八字命理',
    subtitle: '八字命理詳析',
    fourPillarsTitle: '四柱八字',
    dayMaster: '日主',
    rizhu: '日主',
    wuxingTitle: '五行分佈',
    h1: '四柱命盤精準排盤',
    h2: '五行能量深度解析',
    h3: '日主強弱命格推演',
    h4: '八字運勢全面解讀',
  },
  ziweiShare: {
    cardTitle: '紫微斗數分享卡片',
    badge: '紫微命盤',
    subtitle: '紫微斗數命盤詳析',
    lifeStar: '命主',
    bodyStar: '身主',
    branchSuffix: '宮',
    stemSuffix: '干',
    lifePalaceStars: '命宮主星',
    natalSihua: '本命四化',
    liunian: '流年運勢',
    ageUnit: '歲',
    current: '當前',
    emptyRun: '空宮',
    mingpanTitle: '紫微命盤圖',
    h1: '十二宮命盤精準排盤',
    h2: '主星輔星格局推演',
    h3: '大限流年運勢解析',
    h4: '四化飛星命格解讀',
  },
  zhouyiShare: {
    cardTitle: '周易占卜分享卡片',
    badge: '周易占卜',
    subtitle: '六爻起卦詳析',
    hexagramTitle: '主卦·變卦',
    trigramTitle: '八宮納甲',
    danyaoTitle: '動爻',
    h1: '六爻起卦精準排盤',
    h2: '八宮納甲深層解析',
    h3: '動爻變化吉凶推演',
    h4: '五行生克全面解讀',
  },
  astroShare: {
    cardTitle: '占星運勢分享卡片',
    badge: '占星運勢',
    subtitle: '星盤命盤詳析',
    sunSign: '太陽星座',
    moonSign: '月亮星座',
    risingSign: '上升星座',
    houseTitle: '宮位格局',
    transitTitle: '行星運勢',
    h1: '十二宮位精準排盤',
    h2: '太陽月亮上升解析',
    h3: '行星過境運勢推演',
    h4: '星盤格局全面解讀',
  },
  tarotShare: {
    cardTitle: '塔羅牌陣分享卡片',
    badge: '塔羅牌陣',
    subtitle: '塔羅牌陣詳析',
    dailyCard: '今日塔羅',
    spreadName: '牌陣',
    upright: '正位',
    reversed: '逆位',
    energyTitle: '牌陣能量',
    h1: '塔羅牌陣精準排陣',
    h2: '牌義能量深層解析',
    h3: '正位逆位吉凶推演',
    h4: '塔羅運勢全面解讀',
  },
  qizhengShare: {
    cardTitle: '七政四餘分享卡片',
    badge: '七政命盤',
    subtitle: '七政四餘命盤詳析',
    bodyStar: '身主',
    lordTitle: '命主',
    qintangTitle: '琴堂格局',
    qiTitle: '七政排布',
    h1: '十二宮命盤精準排盤',
    h2: '七政四餘格局推演',
    h3: '大限流年運勢解析',
    h4: '四餘飛星命格解讀',
  },
  physiognomyShare: {
    cardTitle: '面相手相分享卡片',
    badge: '相學分析',
    subtitle: '面相手相詳析',
    faceTitle: '面相五行',
    handTitle: '手相格局',
    fateLine: '命運線',
    wealthLine: '財富線',
    h1: '面相十二宮精準排盤',
    h2: '手相三線深度解析',
    h3: '骨相體相格局推演',
    h4: '相學運勢全面解讀',
  },
  dreamShare: {
    cardTitle: '周公解夢分享卡片',
    badge: '夢境解析',
    subtitle: '夢境心理詳析',
    dreamSymbol: '夢兆',
    moodTitle: '夢境情緒',
    zhougongTitle: '周公解夢',
    psychoTitle: '心理分析',
    h1: '夢境符號精準解析',
    h2: '周公解夢深層含義',
    h3: '心理情緒綜合分析',
    h4: '夢境運勢全面解讀',
  },
  shengbeiShare: {
    cardTitle: '聖杯問卜分享卡片',
    badge: '聖杯問卜',
    title: '聖杯問卜',
    subtitle: '擲筊問天 · 神明降示',
    brandSlogan: '誠心祈問 · 天意自明',
    questionLabel: '所問之事',
    onceMode: '擲一次',
    threeMode: '擲三次',
    interpretation: '筊象解讀',
    guidance: '神明指引',
  },
};